// src/utils/logger.js
import { v4 as uuidv4 } from 'uuid';

export const createCorrelationId = () => uuidv4();

const log = (level, cid, message, data) => {
  const timestamp = new Date().toISOString().replace('T', ' ').split('.')[0]; 
  const displayCid = cid || 'no-cid';
  
  // Format mirrors backend: timestamp - LEVEL - [cid] - message
  const logHeader = `${timestamp} - ${level.toUpperCase()} - [${displayCid}]`;
  
  // Use console.debug for trace/debug levels
  const consoleMethod = (level === 'trace' || level === 'debug') ? 'debug' : level;

  if (data) {
    console[consoleMethod](`${logHeader} - ${message}`, data);
  } else {
    console[consoleMethod](`${logHeader} - ${message}`);
  }
};

export const logger = {
  trace: (cid, message, data = null) => log('trace', cid, message, data),
  debug: (cid, message, data = null) => log('debug', cid, message, data),
  info: (cid, message, data = null) => log('info', cid, message, data),
  warn: (cid, message, data = null) => log('warn', cid, message, data),
  error: (cid, message, error = null) => log('error', cid, message, error),
};

export const correlationMiddleware = (options = {}) => {
  const cid = createCorrelationId();
  return {
    options: {
      ...options,
      headers: { ...options.headers, 'X-Correlation-ID': cid },
    },
    cid,
  };
};